import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted, {
  position: 'bottom-center',
  duration: 3000,
  theme: 'bubble',
  singleton: true,
  iconPack: 'custom-class'
})
